




































import { Component, Vue, Prop } from 'vue-property-decorator';

import RiskResources from '@/services/RiskResources';
import UnixDate from '@/utils/DateTime.ts';

@Component({
	name: 'ClaimReviewCard',
})
export default class ClaimReviewCard extends Vue {
	private RiskResources: typeof RiskResources = RiskResources;
	private DateTime: typeof UnixDate = UnixDate;
}
